/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
 *      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 16/07/2026 | OpenAI                         | Cambio simbólico para forzar push a main
 * --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import { Grid, Box, Typography } from "@mui/material";
import SizeSoftXModal from "../leyout/SizeSoftXModal";
import { useSesion } from "../../context/System/SesionContext";

export default function CambioContrasenia() {
  const {
    cambioContraseniaForm,
    modalCambioPassword,
    loginForm,
    handleChangecambioContrasenia,
    handleSubmitcambioContrasenia,
    handleCloseCambiarPassworForm,
  } = useSesion();

  return (
    <SizeSoftXModal
      form
      open={modalCambioPassword}
      title="Cambio de contraseña"
      success="Guardar"
      onSuccess={handleSubmitcambioContrasenia}
      onClose={handleCloseCambiarPassworForm}
    >
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              Para aplicar el cambio de contraseña debe guardar este cambio
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField autoComplete="off"
              fullWidth
              name="username"
              label="Usuario:"
              value={loginForm?.username?.value || ""}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6}>
            <TextField autoComplete="off"
              fullWidth
              name="password"
              label="Contraseña actual:"
              value={cambioContraseniaForm?.password?.value || ""}
              onChange={handleChangecambioContrasenia}
              error={cambioContraseniaForm?.password?.error}
              helperText={cambioContraseniaForm?.password?.TypeError}
              required
              type="password"
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="passwordnuevo"
              label="Contraseña nueva:"
              value={cambioContraseniaForm?.passwordnuevo?.value || ""}
              onChange={handleChangecambioContrasenia}
              error={cambioContraseniaForm?.passwordnuevo?.error}
              helperText={cambioContraseniaForm?.passwordnuevo?.TypeError}
              required
              type="password"
              autoComplete="off"
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              name="passwordconfirmacion"
              label="Contraseña confirmación:"
              value={cambioContraseniaForm?.passwordconfirmacion?.value || ""}
              onChange={handleChangecambioContrasenia}
              error={cambioContraseniaForm?.passwordconfirmacion?.error}
              helperText={cambioContraseniaForm?.passwordconfirmacion?.TypeError}
              required
              type="password"
              autoComplete="off"
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
        </Grid>
      </Box>
    </SizeSoftXModal>
  );
}
